<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12" class="ion-text-center">
                <h3>Configurações de Entidades</h3>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col size="12">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>
                            {{ item?.Description || 'Configuração sem descrição' }}
                            <ion-badge *ngIf="item?.Type" [color]="item?.Status ? 'success' : 'medium'">
                                {{ item?.Type?.Name }}
                            </ion-badge>
                        </ion-card-title>
                        <ion-card-subtitle *ngIf="item?.Project">
                            Projeto: {{ item?.Project?.Name }}
                        </ion-card-subtitle>
                        <ion-card-subtitle *ngIf="item?.Platform">
                            Plataforma: {{ item?.Platform?.Name }}
                        </ion-card-subtitle>
                    </ion-card-header>

                    <ion-card-content>
                        <!-- Informações Básicas -->
                        <ion-row>
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="information-circle-outline" slot="start"></ion-icon>
                                    <ion-label><strong>ID:</strong> {{ item?.Id }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado em:</strong> {{ item?.CreateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Criado por:</strong> {{ item?.CreateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.UpdateDate">
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="calendar-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Atualizado em:</strong> {{ item?.UpdateDate | date:'medium'
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                            <ion-col size="6">
                                <ion-item lines="none">
                                    <ion-icon name="person-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Atualizado por:</strong> {{ item?.UpdateUser }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de URL e Endpoints -->
                        <ion-row *ngIf="item?.Url">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="link-outline" slot="start"></ion-icon>
                                    <ion-label><strong>URL:</strong> {{ item?.Url }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Project?.EndPoint">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="server-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Endpoint:</strong> {{ item?.Project?.EndPoint }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <!-- Configurações de Autenticação -->
                        <ion-row *ngIf="item?.ClientId">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="key-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Client ID:</strong> {{ item?.ClientId }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.ClientSecret">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Client Secret:</strong>
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleSecretVisibility(item)">
                                            <ion-icon
                                                [name]="item.showSecret ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showSecret">{{ item?.ClientSecret }}</span>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Token">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="shield-checkmark-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Token:</strong>
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleTokenVisibility(item)">
                                            <ion-icon
                                                [name]="item.showToken ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showToken">{{ item?.Token }}</span>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Account">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="person-circle-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Conta:</strong>
                                        <div class="account-info" [innerHTML]="formatAccountInfo(item?.Account)"></div>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Licensekey">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="document-text-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>License Key:</strong>
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="toggleLicenseVisibility(item)">
                                            <ion-icon
                                                [name]="item.showLicense ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showLicense">{{ item?.Licensekey }}</span>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Password">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="lock-closed-outline" slot="start"></ion-icon>
                                    <ion-label>
                                        <strong>Password:</strong>
                                        <ion-text class="sensitive-data">••••••••••••</ion-text>
                                        <ion-button fill="clear" size="small" (click)="togglePasswordVisibility(item)">
                                            <ion-icon
                                                [name]="item.showPassword ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                                        </ion-button>
                                        <span *ngIf="item.showPassword">{{ item?.Password }}</span>
                                    </ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Scopes">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="list-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Scopes:</strong> {{ item?.Scopes }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.Priority">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="flag-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Prioridade:</strong> {{ item?.Priority }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>

                        <ion-row *ngIf="item?.ReceptionChannel">
                            <ion-col size="12">
                                <ion-item lines="none">
                                    <ion-icon name="mail-open-outline" slot="start"></ion-icon>
                                    <ion-label><strong>Canal de Receção:</strong> {{ item?.ReceptionChannel
                                        }}</ion-label>
                                </ion-item>
                            </ion-col>
                        </ion-row>
                    </ion-card-content>
                </ion-card>
            </ion-col>
            
        </ion-row>
    </ion-grid>
</ion-col>